import React, { useRef, useLayoutEffect, useState } from "react";
import PropTypes from 'prop-types';
import { WonIcon, LostIcon, OnHlodIcon } from "../../../../components/Icons/Icons";

const ArrowPipeline = ({
    stages,
    currentStage,
    onStageClick,
    completedColor = "#0d6efd",
    upcomingColor = "#d3d3d3",
    arrowHeight = 50,
    editableType,
    edit,
    displayData,
    pipeLineStage,
    oldPipeline,
}) => {
    const ArrowStages = stages.slice(0, 6);
    const IconStages = stages.slice(6);
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    useLayoutEffect(() => {
        if (!containerRef.current) return;

        const resizeObserver = new ResizeObserver(() => {
            if (containerRef.current) {
                setContainerWidth(containerRef.current.offsetWidth);
            }
        });

        resizeObserver.observe(containerRef.current);
        setContainerWidth(containerRef.current.offsetWidth);

        return () => resizeObserver.disconnect();
    }, []);

    const arrowWidth = containerWidth / ArrowStages.length;

    return (
        <div style={{ display: 'flex' }}>
            <div ref={containerRef} style={{ width: "100%" }}>
                <svg height={arrowHeight} width={containerWidth} style={{ fontFamily:"'Noto Sans',sans-serif" }}>
                    {ArrowStages.map((stage, i) => {
                        const { pipelineStageId, pipelineStageName } = stage;
                        const x = i * arrowWidth;
                        const isFirst = i === 0;
                        const isLast = i === ArrowStages.length - 1;
                        let points;
                        if (isFirst) {
                            points = `${x},0 ${x + arrowWidth - 10},0 ${x + arrowWidth},${arrowHeight / 2} ${x + arrowWidth - 10},${arrowHeight} ${x},${arrowHeight}`;
                        } else if (isLast) {
                            points = `${x},0 ${x + arrowWidth},0 ${x + arrowWidth},${arrowHeight} ${x},${arrowHeight} ${x + 10},${arrowHeight / 2}`;
                        } else {
                            points = `${x},0 ${x + arrowWidth - 10},0 ${x + arrowWidth},${arrowHeight / 2} ${x + arrowWidth - 10},${arrowHeight} ${x},${arrowHeight} ${x + 10},${arrowHeight / 2}`;
                        }

                        return (
                            <g
                                key={pipelineStageId}
                                onClick={() =>
                                    (displayData?.pipeline_stage === 8 || i === currentStage - 1) ? undefined : (edit && editableType) ? onStageClick(pipelineStageId, pipelineStageName) : undefined}
                                onMouseEnter={() => setHoveredIndex((edit && editableType) ? i : null)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                style={{ cursor: (displayData?.pipeline_stage === 8 || i === currentStage - 1) ? "default" : (edit && editableType) ? "pointer" : "default" }}
                            >
                                <polygon points={points} fill={
                                    hoveredIndex !== null
                                        ? i <= hoveredIndex
                                            ? completedColor // Hover color
                                            : upcomingColor
                                        :
                                        oldPipeline !== null ?
                                            i <= pipeLineStage.findIndex(stage => stage.pipelineStageId === oldPipeline) ? completedColor : upcomingColor
                                            : i <= pipeLineStage.findIndex(stage => stage.pipelineStageId === currentStage) ? completedColor : upcomingColor
                                } />
                                <text
                                    fontFamily="'Noto Sans', sans-serif"
                                    x={x + arrowWidth / 2}
                                    y={arrowHeight / 2}
                                    textAnchor="middle"
                                    fill={
                                        hoveredIndex !== null
                                            ? i <= hoveredIndex
                                                ? "#ffffff" // Hover color
                                                : "#a1a1a1"
                                            :
                                            oldPipeline !== null ?
                                                i <= pipeLineStage.findIndex(stage => stage.pipelineStageId === oldPipeline) ? "#ffffff" : "#a1a1a1"
                                                : i <= pipeLineStage.findIndex(stage => stage.pipelineStageId === currentStage) ? "#ffffff" : "#a1a1a1"
                                    }
                                    fontSize="12"
                                    fontWeight="600"
                                    dominantBaseline="middle"
                                >
                                    {pipelineStageName}
                                </text>
                            </g>
                        );
                    })}
                </svg>
            </div>
            <div style={{ display: 'flex' }}>
                {IconStages.map((item, i) => (
                    <div title={item.pipelineStageName === "Won" ? "Won Deal" : item.pipelineStageName === "Lost" ? "Lost Deal" : "On Hold"}
                        // className={`${item.pipelineStageId === currentStage ? `${item.pipelineStageName}-Icon-Color step-container` : `${item.pipelineStageName}-Icon-Colors step-container`}`}
                        className={`${item.pipelineStageId === currentStage ? `${item.pipelineStageName}-Icon-Color`
                            : `${item.pipelineStageName}-Icon-Colors`} step-container ${edit && editableType ? 'hover-enabled' : ''}`}
                        style={{ cursor: edit && editableType ? "pointer" : "default" }} key={i}
                        role="button"
                        tabIndex={0}
                        // onMouseEnter={() => setHoveredIndex((edit && editableType) ? (item.pipelineStageName === "Won" ? item.pipelineStageId - 1 : null) : null)}
                        // onMouseEnter={() => setHoveredIndex((edit && editableType) ? (item.pipelineStageName === "Won" ? item.pipelineStageId - 1 : null) : null)}
                        // onMouseLeave={() => setHoveredIndex(null)}
                        onKeyDown={(e) => {
                            if (edit && editableType && e.key === 'Enter' || e.key === ' ') {
                                onStageClick(item.pipelineStageId, item.pipelineStageName)
                            }
                        }}
                        onClick={() => {
                            if (edit && editableType) {
                                onStageClick(item.pipelineStageId, item.pipelineStageName)
                            }
                        }}
                    >
                        {item.pipelineStageName === "Won" ?
                            <WonIcon /> : item.pipelineStageName === "Lost" ?
                                <LostIcon /> : (item.pipelineStageName === "on-Hold"||item.pipelineStageName === "On-Hold") ?
                                    <OnHlodIcon /> : ""}
                    </div>
                ))}
            </div>
        </div>
    );
};

ArrowPipeline.propTypes = {
    stages: PropTypes.arrayOf(PropTypes.string).isRequired,
    currentStage: PropTypes.number.isRequired,
    onStageClick: PropTypes.func,
    completedColor: PropTypes.string,
    upcomingColor: PropTypes.string,
    arrowHeight: PropTypes.number,
    oldPipeline: PropTypes.number,
    edit: PropTypes.bool,
    editableType: PropTypes.bool,
    displayData: PropTypes.object,
    pipeLineStage: PropTypes.array,
};

export default ArrowPipeline;
